// extracted by mini-css-extract-plugin
export default {"layoutSwitch":"DesignerInspirationNavigation_layoutSwitch__bcmYQ","paginationSwitch":"DesignerInspirationNavigation_paginationSwitch__TKZgd"};